import tagHttp from './tagHttp';

const getTree = (context) => {
  return new Promise((resolve, reject) => {
    tagHttp.getTree(context)
      .then(data => {
        const response = parseResponse(data.body);
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const getReadTree = (context) => {
  return new Promise((resolve, reject) => {
    tagHttp.getReadTree(context)
      .then(data => {
        const response = parseResponse(data.body);
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const updateTree = (context, tree) => {
  return new Promise((resolve, reject) => {
    const request = parseRequest(tree);
    tagHttp.updateTree(context, request)
      .then(data => {
        const response = parseResponse(data.body);

        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const deleteNodes = (context, nodes) => {
  return new Promise((resolve, reject) => {
    const request = parseRequest(nodes);
    tagHttp.deleteNodes(context, request)
      .then(data => {
        const response = parseResponse(data.body);
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const addTags = (context, variableIds, tagIds) => {
  return new Promise((resolve, reject) => {
    tagHttp.addTags(context, variableIds, tagIds)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const removeTags = (context, variableIds, tagIds) => {
  return new Promise((resolve, reject) => {
    tagHttp.removeTags(context, variableIds, tagIds)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const parseResponse = (tree) => {
  return tree.map(node => {
    return {
      data: {id: node.id},
      text: node.name,
      children: parseResponse(node.children)
    };
  });
};

const parseRequest = (tree) => {
  return tree.map(node => {
    return {
      id: node.data.id,
      name: node.data.text,
      children: parseRequest(node.children)
    };
  });
};

export default {
  getTree,
  getReadTree,
  updateTree,
  deleteNodes,
  addTags,
  removeTags
};



// WEBPACK FOOTER //
// ./src/api/tag/index.js